import { useCurrentGroup } from "./useCurrentGroup";

type GroupAiStatus = {
  isAiEnabled: boolean;
};

export const useGroupAiStatus = (groupId?: string): GroupAiStatus => {
  const { is_ai_enabled } = useCurrentGroup(groupId);

  const isAiEnabled = is_ai_enabled ?? true;

  return { isAiEnabled };
};
